import React, {  Fragment } from "react";
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	Line,
	ResponsiveContainer,
} from "recharts";
import { formatValue } from "../Utils.js";
import { fillColors } from "../../constants.js";





export const PieChartComponent = (props) => {
	const {
		data,
		title,




		name,
		value,
		subtitle,
	} = props;
	const hasData = data && data.length > 0;


    const renderCustomizedLabelLine = (props) => {
        const { percent } = props;
        return percent > 0.02 ? <Line {...props} stroke="hsl(var(--chart-axis))" dot={false} /> : null;
    };


	const renderCustomizedLabel = (props) => {
		const { cx, cy, midAngle, outerRadius, index, value, innerRadius, percent } = props;

		const RADIAN = Math.PI / 180;
		const radius = 25 + innerRadius + (outerRadius - innerRadius);
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		// const displayValue = percent > 0.1 ? formatValue(value, "currency", false) : "";

        if (percent > 0.02) {
            return (
                <text
                    x={x}
                    y={y}
                    fontSize="14px"
                    fill="hsl(var(--chart-axis))"
                    textAnchor={x > cx ? "start" : "end"}
                    dominantBaseline="central"
                >
                    {data[index][name]} {formatValue(value, "currency", false)}
                </text>
			);
		};
	};

	return (
		<div className="bg-card rounded-card border border-card-bd my-2 mr-4 p-4">
			<div className="text-text text-lg font-semibold mt-1 cursor-default" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
				{/* <span className="mx-3">{titleIcon}</span>  */}
				{title}
			</div>
			{hasData ? (
				<Fragment>
					<div className="text-text-2 text-lg font-semibold text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{subtitle}</div>
					<ResponsiveContainer width="100%" height={250}>
						<PieChart>
							<Pie
							dataKey={value}
							nameKey={name}
							isAnimationActive={false}
							data={data}
							cx="50%"
							cy="50%"
							outerRadius={60}
							innerRadius={40}
							fill="#8884d8"
							label={renderCustomizedLabel}
							labelLine={renderCustomizedLabelLine}
						>
							{data.map((entry, index) => (
								<Cell
									key={`cell-${index}`}
									fill={fillColors[index % fillColors.length]}
								/>
							))}
						</Pie>
							{/* <Tooltip /> */}
							<Tooltip
								content={renderTooltip}
								cursor={{ fill: "hsl(var(--chart-grid))" }}
								// cursor={{fill: 'transparent'}}
							/>

						</PieChart>
					</ResponsiveContainer>
				</Fragment>
			) : (
				<div className="text-text-2 text-center"></div>
			)}

		</div>
	);
};

const renderTooltip = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		return (
			<div className="custom-tooltip bg-surface rounded-card border border-card-bd shadow-float p-1 minw-64 ml-8 py-4 px-4">
				<div className="flex flex-row">
					<p className="flex label font-normal mr-4">
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" className="">
							<rect x="0" y="8" width="6" height="6" fill={payload[0].payload.fill} />
						</svg>

						<span className="flex-1 mr-4">{`${payload[0].name}`}</span>
	 					<span className="text-right">{`${formatValue(payload[0].value, "currency", false)}`}</span>
					</p>
				</div>
			</div>
		);
	}

	return null;
};

